(function () {
  var rectoImageUrl = '';
  var pdfSelected = false;

  function getElements() {
    return {
      recto: document.querySelector('[id^="bracelet-recto-"]'),
      verso: document.querySelector('[id^="bracelet-verso-"]'),
      image: document.querySelector('[id^="bracelet-image-"]'),
      font: document.querySelector('[id^="calligraphy-"]'),
      rectoPreview: document.querySelector('[id^="calligraphy-preview-"]:not([id^="calligraphy-preview-verso-"])'),
      versoPreview: document.querySelector('[id^="calligraphy-preview-verso-"]'),
      versoGroup: document.querySelector('[id^="calligraphy-verso-group-"]')
    };
  }

  function selectedRectoVerso() {
    var controls = document.querySelectorAll('input[type="radio"]:checked, select');
    for (var i = 0; i < controls.length; i += 1) {
      var value = controls[i].value || '';
      var optionText = '';
      if (controls[i].tagName === 'SELECT' && controls[i].selectedIndex >= 0) {
        optionText = controls[i].options[controls[i].selectedIndex].text || '';
      }
      var text = (value + ' ' + optionText).toLowerCase();
      if (text.indexOf('recto et verso') !== -1 || text.indexOf('recto & verso') !== -1 || text.indexOf('recto-verso') !== -1) return true;
    }
    return false;
  }

  function isRectanglePreview() {
    return Boolean(document.querySelector('.bracelet-engraving--rectangle'));
  }

  function fitText(preview) {
    var styles = getComputedStyle(preview);
    var horizontalPadding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
    var verticalPadding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
    var width = Math.max(30, preview.clientWidth - horizontalPadding - 8);
    var height = Math.max(22, preview.clientHeight - verticalPadding - 8);
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    var rootSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    var px = Math.min(7 * rootSize, height * 0.82);
    do {
      context.font = px + 'px ' + styles.fontFamily;
      if (context.measureText(preview.textContent).width <= width) break;
      px -= 2;
    } while (px > 16);
    preview.style.fontSize = Math.max(16, px) + 'px';
  }

  function clearImagePreview(preview) {
    preview.style.backgroundImage = '';
    preview.style.backgroundPosition = '';
    preview.style.backgroundRepeat = '';
    preview.style.backgroundSize = '';
  }

  function update() {
    var el = getElements();
    if (!el.recto || !el.font || !el.rectoPreview) return;

    var fonts = {
      'Playball': "'Playball', cursive",
      'Times New Roman': "'Times New Roman', serif",
      'Montserrat': "'Montserrat', sans-serif",
      'Great Vibes': "'Great Vibes', cursive"
    };
    var family = fonts[el.font.value] || "'Montserrat', sans-serif";
    var rectoText = el.recto.value.trim();

    if (rectoImageUrl) {
      el.rectoPreview.textContent = '\u00a0';
      el.rectoPreview.style.color = 'transparent';
      el.rectoPreview.style.backgroundImage = 'url("' + rectoImageUrl + '"), linear-gradient(135deg, var(--preview-metal-light, #fafafa), var(--preview-metal-base, #ddd) 50%, var(--preview-metal-dark, #aaa))';
      el.rectoPreview.style.backgroundPosition = 'center';
      el.rectoPreview.style.backgroundRepeat = 'no-repeat';
      el.rectoPreview.style.backgroundSize = 'contain';
      el.rectoPreview.setAttribute('aria-label', 'Aperçu noir et blanc de l’image à graver au recto');
    } else {
      clearImagePreview(el.rectoPreview);
      el.rectoPreview.style.color = '';
      el.rectoPreview.textContent = pdfSelected ? 'Aperçu PDF indisponible' : (rectoText || 'Votre texte');
      el.rectoPreview.style.fontFamily = family;
      if (pdfSelected) el.rectoPreview.style.fontSize = '1.5rem'; else fitText(el.rectoPreview);
      el.rectoPreview.setAttribute('aria-label', 'Aperçu de la gravure au recto');
    }

    if (el.versoGroup && el.versoPreview) {
      var showVerso = selectedRectoVerso();
      el.versoGroup.hidden = !showVerso;

      if (showVerso) {
        var versoText = el.verso ? el.verso.value.trim() : '';
        el.versoPreview.textContent = versoText || 'Votre texte verso';
        el.versoPreview.style.fontFamily = family;
        fitText(el.versoPreview);
      }
    }
  }

  function createBlackAndWhitePreview(file) {
    pdfSelected = false;
    rectoImageUrl = '';

    if (!file) {
      update();
      return;
    }

    if (file.type === 'application/pdf' || /\.pdf$/i.test(file.name)) {
      pdfSelected = true;
      update();
      return;
    }

    if (!file.type.match(/^image\/(jpeg|png)$/)) {
      update();
      return;
    }

    var sourceUrl = URL.createObjectURL(file);
    var sourceImage = new Image();

    sourceImage.onload = function () {
      var canvas = document.createElement('canvas');
      var canvasWidth = isRectanglePreview() ? 590 : 1000;
      var canvasHeight = 1000;
      var padding = isRectanglePreview() ? 45 : 70;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      var context = canvas.getContext('2d', { willReadFrequently: true });

      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, canvasWidth, canvasHeight);

      var scale = Math.min(
        (canvasWidth - padding * 2) / sourceImage.naturalWidth,
        (canvasHeight - padding * 2) / sourceImage.naturalHeight
      );
      var width = sourceImage.naturalWidth * scale;
      var height = sourceImage.naturalHeight * scale;
      context.drawImage(sourceImage, (canvasWidth - width) / 2, (canvasHeight - height) / 2, width, height);

      var imageData = context.getImageData(0, 0, canvasWidth, canvasHeight);
      var pixels = imageData.data;
      for (var i = 0; i < pixels.length; i += 4) {
        var luminance = pixels[i] * 0.299 + pixels[i + 1] * 0.587 + pixels[i + 2] * 0.114;
        var blackOrWhite = luminance < 180 ? 0 : 255;
        pixels[i] = blackOrWhite;
        pixels[i + 1] = blackOrWhite;
        pixels[i + 2] = blackOrWhite;
        pixels[i + 3] = blackOrWhite === 255 ? 0 : 255;
      }
      context.putImageData(imageData, 0, 0);
      rectoImageUrl = canvas.toDataURL('image/png');
      URL.revokeObjectURL(sourceUrl);
      update();
    };

    sourceImage.onerror = function () {
      URL.revokeObjectURL(sourceUrl);
      rectoImageUrl = '';
      update();
    };

    sourceImage.src = sourceUrl;
  }

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[id^="bracelet-image-"]')) update();
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[id^="bracelet-image-"]')) {
      createBlackAndWhitePreview(event.target.files && event.target.files[0]);
      return;
    }
    update();
  });

  function initialize() {
    var el = getElements();
    if (el.image && el.image.files && el.image.files[0]) {
      createBlackAndWhitePreview(el.image.files[0]);
    } else {
      update();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
  setTimeout(initialize, 250);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
})();

